<template>
    <div class="page-container">
    <el-breadcrumb separator="/">
     <el-breadcrumb-item>
        <span class="page-title">基金会</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';

export default {
  name: 'foundationProject',
  data() {
    return {};
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('foundationProject', ['pagination'])
  },
  methods: {
    ...mapActions('foundationProject', ['getList', 'getCoinTypeList']),
    getProjectList(data = {}) {
      this.getList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
  }
};
</script>
